export default __webpack_public_path__ + "static/rocket-b746b653a265ad076532e9a842d367d9.svg";